import { type IPolicyPolicyDataPhase } from '@/shared/api/models.bff';
import { parseDate } from './Policy';

const parseNum = (num: string) => {
  const n = +num;
  return !Number.isNaN(n) ? n : 0.0;
};

export interface IPhase {
  coverageAmount: number; // Phase.parseNum(phaseData.coverageAmount)
  inForceCode: string; // phaseData.phInforceCode
  isIbr: boolean; // phaseData.phaseIsIBR === true || phaseData.phaseIsIBR === 'true'
  isAnnuity: boolean; // phaseData.phaseIsAnnuity === true || phaseData.phaseIsAnnuity === 'true'
  issueAge: number; // Phase.parseNum(phaseData.personIssueAge)
  issueDate: Date | null; // Policy.parseDate(phaseData.phIssueDate, 'MM/DD/YYYY')
  issueState: string; // phaseData.phIssueState
  dateOfBirth: Date | null; // Policy.parseDate(phaseData.personDateOfBirth, 'MM/DD/YYYY')
  eotDate: Date | null; // Policy.parseDate(phaseData.phaseEOTDate)
  premium: number; // Phase.parseNum(phaseData.phPremium)
  insuredName: string; // `${phaseData.personFirstName} ${phaseData.personLastName}`
  isChild: boolean; // phaseData.person.length === 2 && phaseData.person.slice(0, 1) === '2'
  person: string; // this?.phPlanzPerson
  planDescription: string; // phaseData.planDescription || ''
  planDescriptionFrench: string; // phaseData.planDescriptionFrench || ''
  planText: string; // phaseData.planzText || ''
  sequenceNumber: string; // phaseData.phaseSequenceNo
  sex: string; // phaseData.personSex
  underwritingClass: string; // phaseData.phUndwPremClass || ''
  wpPrem: number; // Phase.parseNum(phaseData.phWPPrem)
  wpPremSpouse: number; // Phase.parseNum(phaseData.phWPPremSpouse)
  phaseNo?: string;
  personTaxId?: string;
  phPlan?: string;
  phOtherPrem?: string;
}

export const mapPhaseResponse = (phaseData: IPolicyPolicyDataPhase): IPhase => {
  const mappedPhase = {
    coverageAmount: parseNum(phaseData.coverageAmount),
    inForceCode: phaseData.phInforceCode,
    isIbr: phaseData.phaseIsIBR,
    isAnnuity: phaseData.phaseIsAnnuity === 'true',
    issueAge: parseNum(phaseData.personIssueAge),
    issueDate: parseDate(phaseData.phIssueDate, 'MM/dd/yyyy'),
    issueState: phaseData.phIssueState,
    dateOfBirth: parseDate(phaseData.personDateOfBirth, 'MM/dd/yyyy'),
    eotDate: parseDate(phaseData.phaseEOTDate, 'MM/dd/yyyy'),
    premium: parseNum(phaseData.phPremium),
    insuredName: `${phaseData.personFirstName} ${phaseData.personLastName}`,
    isChild: phaseData.phPlanzPerson.length === 2 && phaseData.phPlanzPerson.startsWith('2'),
    person: phaseData.phPlanzPerson,
    planDescription: phaseData.planDescription || '',
    planDescriptionFrench: phaseData.planDescriptionFrench || '',
    planText: phaseData.planzText,
    sequenceNumber: phaseData.phaseSequenceNo,
    sex: phaseData.personSex,
    underwritingClass: phaseData.phUndwPremClass || '',
    wpPrem: parseNum(phaseData.phWPPrem),
    wpPremSpouse: parseNum(phaseData.phWPPremSpouse),
    phaseNo: phaseData.phaseNo,
    personTaxId: phaseData.personTaxId,
    phPlan: phaseData.phPlan,
    phOtherPrem: phaseData.phOtherPrem,
  };
  return mappedPhase;
};
